angular.module('natgeo').controller('CreditScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ScreenView', 
function CreditScreen($scope, element, ScreenFactory, manager, container, ScreenView)
{
	var screen = ScreenFactory( 'credits', element );
	
  // Close the Credit Screen
  $scope.close = function()
  {
    ScreenView.change( 'splash', 'splash_splash', false, 2000, 'loading_game' );
  };

  // Before the screen is introduced, let the credits directive know we're ready.
  screen.on('introBefore', function()
  {
    element.find('credits')
      .trigger('prepare')
    ;
    element.find('[data-show]')
      .addClass('hidden')
    ;
  });

  // Run the show animations since there are no intro animations.
  screen.on('introBegin', function()
  {
    element.find('credits')
      .trigger('ready')
    ;
    element.find('[data-show]')
      .removeClass('hidden')
      .dataPlay('show')
      .applyInitialState()
    ;
  });

}]);